module.exports = __webpack_public_path__ + "img/Wolt.06191691.jpg";